import { render, staticRenderFns } from "./SubirPlanilha.vue?vue&type=template&id=0b8dc6d0"
import script from "./SubirPlanilha.vue?vue&type=script&lang=js"
export * from "./SubirPlanilha.vue?vue&type=script&lang=js"
import style0 from "./SubirPlanilha.vue?vue&type=style&index=0&id=0b8dc6d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports